export const buildInitialState = (overrides) => ({
  openKudosCommentModal: false,
  selectedTabIndex: 0,
  kudoPosted: false,
  newComment: null,
  openCommentDeleteDialog: false,
  ...overrides
});

export default { buildInitialState };
